import styled from 'styled-components'

import { fontSize, fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  padding-top: 3rem;
  height: 100%;

  ${media.desktop} {
    padding-top: unset;
  }
`

export const Title = styled.h3`
  font-size: ${fontSize.LARGE_XXXL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.GREYISH_BROWN};
  margin-top: 2rem;
  text-align: center;

  ${media.desktop} {
    margin-top: 5.5rem;
    font-size: ${fontSize.LARGE_XXL};
  }
`
export const ListWrap = styled.div`
  background-color: ${color.WHITE};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;

  ${media.desktop} {
    background-color: unset;
  }
`

export const RowWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.2rem 0;
  width: 100vw;
  padding: 0 3rem;

  > svg {
    flex-shrink: 0;
  }

  ${media.desktop} {
    padding: 0;
    width: 40rem;
  }
`

export const SubTitle = styled.h4`
  font-size: ${fontSize.LARGE_XL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.WARM_GREY};
  margin: 0;
  text-align: center;
  flex-shrink: 2;
  padding: 0 2rem;
`

export const QuestionTitle = styled.span`
  font-weight: ${fontWeight.SEMI};
`
